import SavedSearchConstants from '../constants/SavedSearchConstants';
import SavedSearchApi from '../api/SavedSearchApi';
import composeSuccessMessaging from '../helpers/messaging/composeSuccessMessaging';

function removeTitleFromQuery(query) {
  return query.replace(/title=[^&]+/g, '');
}

export function saveSearch(name, query) {
  return {
    types: [
      SavedSearchConstants.SAVE_REQUEST,
      SavedSearchConstants.SAVE_SUCCESS,
      SavedSearchConstants.SAVE_FAILURE
    ],
    payload: { name },
    apiRequest: (state, apiClient) => SavedSearchApi.saveSearch(name, removeTitleFromQuery(query), apiClient),
    apiSuccess: () => ({
      messaging: composeSuccessMessaging(
        'searchTitle',
        'saved_search_success',
        { values: { search_name: name } }
      )
    }),
    apiFailure: () => ({
      messaging: null
    })
  };
}

export function replaceSearch(query) {
  return {
    types: [
      SavedSearchConstants.SAVE_REQUEST,
      SavedSearchConstants.SAVE_SUCCESS,
      SavedSearchConstants.SAVE_FAILURE
    ],
    payload: { name },
    apiRequest: (state, apiClient) =>
      SavedSearchApi.replaceSearch(
        state.getIn(['ui', 'savedSearch', 'lastNameAttempt']),
        removeTitleFromQuery(query),
        state.getIn(['ui', 'savedSearch', 'duplicateSearchId']),
        apiClient
      )
  };
}

export function chooseNewName() {
  return {
    type: SavedSearchConstants.CHOOSE_NEW_NAME
  };
}

export default {
  saveSearch,
  replaceSearch,
  chooseNewName
};



// WEBPACK FOOTER //
// ./app/actions/SavedSearchActions.js